<template>
  <div class="row box-row">
    <div class="col form-group form-check">
      <input
        v-if="!stockMode"
        :id="'item_' + item.ADDID"
        type="checkbox"
        class="form-check-input"
        :checked="isSelectedEquipment(item)"
        @change.prevent="toggleEquipment(item)"
      >
      <label
        :for="'item_' + item.ADDID"
        class="box-label form-check-label d-flex justify-content-between"
      >
        <template v-if="!isPackage">
          {{ item.name }}
        </template>
        <template v-else>
          {{ item.name }}
          <addition-info v-if="item.info.length > 0">
            {{ item.info }}
          </addition-info>
        </template>
      </label>
    </div>
    <div
      v-if="!stockMode"
      class="col box-value"
    >
      {{ getEquipmentMonthlyPrice(item) | currency }} Ft
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { Component, Prop } from 'vue-property-decorator';
  import _ from 'lodash';
  import {namespace} from 'vuex-class';
  import AdditionInfo from '../AdditionInfo';

  const configuratorModule = namespace('configurator');

  @Component({
    components: {AdditionInfo}
  })
  export default class ExtraEquipmentInPackage extends Vue {
    @Prop(Object) item;

    @configuratorModule.State('stockMode') stockMode;
    @configuratorModule.Getter('getEquipmentMonthlyPrice') getEquipmentMonthlyPrice;
    @configuratorModule.Getter('isSelectedEquipment') isSelectedEquipment;
    @configuratorModule.Action('toggleEquipment') toggleEquipment;

    get isPackage() {
      return _.startsWith(this.item.ADDEQCode, 9)
    }
  }
</script>
